import React from 'react';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { RefreshCallback } from '../../../_lib/FetchContainer';
import { CheckBoxParam, Form, Row, SonForm, SubmitButton, Switch, useForm } from '../../../_lib/Form2';
import { useDelayed } from '../../../hooks/useDelayed';
import { ContentParagraph } from '../../../_lib/components/ContentParagraph';

export type TableOfContentsForm = {
  form: SonForm<CheckBoxParam<'visible'>>;
  refreshBlock: RefreshCallback;
};

export function TableOfContentsForm({ form, refreshBlock }: TableOfContentsForm) {
  const { t } = useSonTranslation('TableOfContents');
  const delayedRefresh = useDelayed(refreshBlock);

  const { formProps, params, fetchState } = useForm({ form, onSuccess: delayedRefresh });

  const switchParam = params.getByName('visible');

  return (
    <Form id="table-of-contents" {...formProps}>
      <Row>
        <ContentParagraph>{t('edit.explainingText')}</ContentParagraph>
      </Row>
      <Switch label={t('edit.labelTitle')} param={switchParam} />
      <SubmitButton
        active={fetchState.type === 'initial' || fetchState.type === 'error'}
        buttonLabel={t('edit.submit')}
        messageSuccess={t('phrases:actionSuccesfull')}
        messageSending={t('phrases:processIsCurrentlyRunning')}
        messageFail={t('phrases:actionCouldNotBeCompleted')}
        fetchState={fetchState}
      />
    </Form>
  );
}
